import React from 'react';
import styles from './Header.module.css';
import logo from '../../../_shared-user/h2o-logo-header.webp';

/**
 * Компонент Header - отображает заголовок приложения
 * @param {Object} props - Свойства компонента
 * @param {string} props.theme - Тема оформления ('light' или 'dark')
 * @param {Function} props.onBack - Функция для обработки нажатия на стрелку назад (опционально)
 */
const Header = ({ theme = 'light', onBack }) => {
  return (
    <header className={styles.header}>
      {onBack && (
        <button
          onClick={onBack}
          className={styles.backButton}
          type="button"
          aria-label="Назад"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      )}
      <div className={styles.logo}>
        <img src={logo} alt="Автомойка H2O" className={styles.logoImg} />
      </div>
    </header>
  );
};

export default Header;
